import React, { useEffect, useState } from 'react'
import { Responsive, WidthProvider } from 'react-grid-layout'
import { Box, useTheme } from '@mui/material'

import './style.css'
import MonPortrait from './Component/Card/MonPortrait'
import ProfilInvesti from './Component/Card/ProfilInvesti'
import MonPatrimoineCard from './Component/Card/MonPatrimoineCard'
import PatrimoineNetCard from './Component/Card/PatrimoineNetCard'
import MesObjectifsCard from './Component/Card/MesObjectifsCard'
import ConseilsCard from './Component/Card/ConseilsCard'
import urls from 'utils/urls'
import MonBudget from './Component/Card/MonBudget'
import MaSimulation from './Component/Card/MaSimulation'
import { makeGetRequest } from 'utils/api'
const ResponsiveGridLayout = WidthProvider(Responsive)

function MonPatrimoine() {
  const theme = useTheme()
  const [reports, setReports] = useState([])
  useEffect(() => {
    MonPatrimoineReports()
  }, [])
  const MonPatrimoineReports = async () => {
    const { data } = await makeGetRequest(urls.MonBilanPatrimonialReports, {}, true)
    // const { data } = await makeGetRequest(urls.MonBilanPatrimonialReports,{},true)
    setReports([...data])
  }
  const layout1 = [
    { i: '1', x: 0, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '2', x: 3, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '3', x: 6, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '4', x: 9, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '5', x: 0, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '6', x: 3, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '7', x: 6, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '8', x: 9, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
  ]
  const layout2 = [
    { i: '1', x: 0, y: 0, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '2', x: 5, y: 0, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '3', x: 0, y: 0, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '4', x: 5, y: 0, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '5', x: 0, y: 5, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '6', x: 5, y: 5, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '7', x: 0, y: 5, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '8', x: 5, y: 5, w: 5, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
  ]
  const layout3 = [
    { i: '1', x: 0, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '2', x: 3, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '3', x: 0, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '4', x: 3, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '5', x: 0, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '6', x: 3, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '7', x: 0, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '8', x: 3, y: 5, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
  ]
  const layout4 = [
    { i: '1', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '2', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '3', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '4', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '5', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '6', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '7', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '8', x: 0, y: 5, w: 4, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
  ]
  const layouts = { lg: layout1, md: layout2, sm: layout3, xs: layout4 }

  const xArr = [0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9]
  const children = React.useMemo(() => {
    return (
      reports &&
      reports.map((val, idx) => (
        <div
          key={idx}
          style={{ backgroundColor: theme.palette.appBar.main, display: 'grid' }}
          data-grid={{
            x: xArr[idx],
            y: Infinity,
            w: 3,
            h: 3,
            minW: 2,
            maxW: 8,
            minH: 3,
            maxH: 10,
          }}
        >
          {val.type === 'mon-portrait' && (
            <MonPortrait updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
          {val.type === 'profil-investisseure' && (
            <ProfilInvesti updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
          {val.type === 'mon-budget' && (
            <MonBudget updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
          {val.type === 'mon-patrimoine' && (
            <MonPatrimoineCard updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
          {val.type === 'patrimoine-net' && (
            <PatrimoineNetCard updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
          {val.type === 'mes-objectifs' && (
            <MesObjectifsCard updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
          {val.type === 'ma-simulation' && (
            <MaSimulation updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
          {val.type === 'conseils' && (
            <ConseilsCard updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
        </div>
      ))
    )
  }, [reports])

  return (
    <Box maxWidth={1650} ml={'auto'} mr={'auto'}>
      <ResponsiveGridLayout
        className="layout"
        style={{ margin: '10px' }}
        autoSize={true}
        layouts={layouts}
        useCSSTransforms={true}
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
        draggableCancel=".no-drag"
      >
        {children}
      </ResponsiveGridLayout>
    </Box>
  )
}

export default MonPatrimoine
